"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactForm = require("react-form");

var Form = function Form(_ref) {
  var defaultValues = _ref.defaultValues,
      children = _ref.children,
      onValidate = _ref.onValidate,
      onSubmit = _ref.onSubmit,
      className = _ref.className,
      formProps = (0, _objectWithoutPropertiesLoose2.default)(_ref, ["defaultValues", "children", "onValidate", "onSubmit", "className"]);

  var _useForm = (0, _reactForm.useForm)((0, _extends2.default)({
    onSubmit: onSubmit,
    defaultValues: defaultValues,
    validate: onValidate
  }, formProps)),
      Form = _useForm.Form;

  return /*#__PURE__*/_react.default.createElement(Form, {
    className: className
  }, children);
};

Form.propTypes = {
  /** Initial form value */
  defaultValues: _propTypes.default.object,

  /** Callback function fired when a form is submitted.
   * Params:
   - __values__ : Form values
   - __instance__ : [Form instance](https://github.com/tannerlinsley/react-form/blob/HEAD/docs/api.md#form-instance) */
  onSubmit: _propTypes.default.func,

  /** Callback function fired when a form is validated.
   * Params:
   - __values__ : Form values
   - __instance__ : [Form instance](https://github.com/tannerlinsley/react-form/blob/HEAD/docs/api.md#form-instance) */
  onValidate: _propTypes.default.func,

  /** Form content. Can be any [formalized](#formalizer) component or not */
  children: _propTypes.default.node,

  /** It extends Form styles. */
  className: _propTypes.default.node
};
Form.defaultProps = {
  initialValue: {},
  onChange: function onChange() {
    return null;
  },
  onSubmit: function onSubmit() {
    return null;
  }
};
Form.displayName = 'Form';
var _default = Form;
exports.default = _default;